import { Column } from '~components/table-view';
import dayjs, { datePickerDisplayFormat } from '~libs/dayjs';

export const dexIssueColumns: Column[] = [
  { id: 'appointment_id', header: 'Appt ID', type: 'text', style: { width: '90px' } },
  { id: 'client_name', header: 'Client', type: 'text' },
  {
    id: 'date',
    header: 'Date',
    type: 'text',
    style: { width: '110px' },
    deriveValue: (row) => (row.date ? dayjs(row.date).format(datePickerDisplayFormat) : ''),
  },
  { id: 'reason', header: 'Reason', type: 'text' },
];
